import { Link } from "react-router-dom";

export function ProductCard({ product }) {
  return (
    <Link to={`/shop/${product.slug}`} data-testid={`product-card-${product.slug}`} className="group block">
      <div className="relative aspect-square [filter:drop-shadow(0_6px_14px_rgba(17,17,17,0.14))] [@media(hover:hover)]:group-hover:[filter:drop-shadow(0_10px_20px_rgba(17,17,17,0.20))] [@media(hover:hover)]:group-hover:-rotate-1 transition-transform duration-200">
        <img
          src="/assets/torn-paper-blank.png"
          alt=""
          aria-hidden
          draggable={false}
          className="absolute inset-0 w-full h-full object-contain pointer-events-none select-none"
        />
        <img
          src={product.images[0]}
          alt={product.name}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-contain p-12 transition-transform duration-300 [@media(hover:hover)]:group-hover:scale-[1.04]"
        />
        {product.seasonal_tag && (
          <span
            data-testid={`seasonal-badge-${product.slug}`}
            className="absolute top-6 left-8 bg-navy text-paper font-college text-sm px-2 py-0.5 -rotate-3"
          >
            {product.seasonal_tag}
          </span>
        )}
      </div>
      <div className="mt-3 flex items-start justify-between gap-3">
        <h3 className="font-college text-navy leading-tight">{product.name}</h3>
        <span className="font-semibold shrink-0">${product.price}</span>
      </div>
      <p className="text-xs text-ink/50 mt-0.5 tracking-wide">{product.category}</p>
    </Link>
  );
}
